import React from 'react'
import { Container, Image, Segment, TextArea } from 'semantic-ui-react'

import edit from '../../assets/images/edit-small.png'
import { tr } from '../../helpers/languages'

const Notes = (props) => {
    return (
        <Container className='session-notes'>
            <Segment className='section-title'>
                {tr('SESSION_NOTES')}
                {
                    !props.editable && (
                        <Image src={edit} onClick={(_e) => { props.onToggleEditing() }}/>
                    )
                }
            </Segment>
            <Segment className='notes'>
                <TextArea
                    name='notes'
                    disabled={!props.editable}
                    placeholder={tr('KEEP_HERE_EXTRA_NOTES')}
                    maxLength={5000}
                    value={props.session.notes}
                    onChange={(e) => { props.onChangeValue(e.target.name, e.target.value) }}
                />
            </Segment>
        </Container>
    )
}

export default Notes



// WEBPACK FOOTER //
// ./src/components/participant-session/notes.js